import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppBar, Box, Toolbar, IconButton, Typography, Menu, Button, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Colors } from '../../helpers/Colors.js';
import { useAuth } from 'context/AuthContext.jsx';
import { AccountCircle } from '@mui/icons-material';



const Navbar = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const { user, signOut } = useAuth(); // Get user and signOut function from context
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(); // Sign out the user
            navigate('/'); // Optionally navigate to the sign-in page after logging out
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    const pages = [
        { title: 'Home', link: '/' },
        { title: 'Trips', link: '/profile' }
    ];
    const authPages = [
        { title: 'About', link: '/about' },
        {
            title: user ? 'Logout' : 'Sign Up', link: user ? '#' : '/signup', action: user ? handleLogout : undefined
        },
    ];
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    return (
        <AppBar position='static' sx={{ backgroundColor: Colors.green }}>
            <Toolbar disableGutters>
                <Typography
                    variant='h6'
                    noWrap
                    component={Link}
                    to='/'
                    sx={{
                        ml: 2,
                        display: { xs: 'none', md: 'flex' },
                        flexGrow: 1,
                        fontFamily: 'Open Sans',
                        fontWeight: 700,
                        letterSpacing: '.1rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    TravelGreen
                </Typography>

                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: { xs: 'none', md: 'flex-end' } }}>
                    {pages.map((page) => (
                        <Button component={Link} to={page.link} onClick={page.action ? page.action : undefined} key={page.title} sx={{ my: 2, color: 'white', display: 'block' }}>
                            {page.title}
                        </Button>
                    ))}
                        <div style={{display:"flex", justifyContent:"center", alignContent:"center"}}>
                            <Button
                                size="small"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </Button>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem component={Link} to={"/about"} onClick={handleClose}>About</MenuItem>
                                <MenuItem component={Link} to={user ? "#" : "/signup"} onClick={user ? handleLogout : handleClose}>{user ? 'Sign out' : 'Sign up'}</MenuItem>
                            </Menu>
                        </div>
                </Box>

                {/* For small screen */}
                <Typography
                    variant='body1'
                    noWrap
                    component={Link}
                    to='/'
                    sx={{
                        ml: 2,
                        display: { xs: 'flex', md: 'none' },
                        flexGrow: 1,
                        fontFamily: 'Open Sans',
                        fontWeight: 700,
                        letterSpacing: '.4rem',
                        color: 'inherit',
                        textDecoration: 'none',
                    }}
                >
                    TravelGreen
                </Typography>
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: { xs: 'flex-end', md: 'none' } }}>
                    <IconButton size='large' aria-controls='menu-appbar' aria-haspopup='true' onClick={handleOpenNavMenu} color='inherit'>
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id='menu-appbar'
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                        }}
                    >
                        {pages.map((page) => (
                            <MenuItem key={page.title} onClick={handleCloseNavMenu}>
                                <Typography component={Link} to={page.link} onClick={page.action ? page.action : undefined} textAlign='center' sx={{ textDecoration: 'none' }}>
                                    {page.title}
                                </Typography>
                            </MenuItem>
                        ))}
                        {authPages.map((page) => (
                            <MenuItem key={page.title} onClick={handleCloseNavMenu}>
                                <Typography component={Link} to={page.link} onClick={page.action ? page.action : undefined} textAlign='center' sx={{ textDecoration: 'none' }}>
                                    {page.title}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};
export default Navbar;
